module.exports = "/_next/static/images/fb5daa6eea17bd2db7e842d72b5f018f-man-looking-up-smiling-lg@1x.jpg.webp";